import React from 'react'
import './page_circle_progress.css'
export default function PageCircleProgress() {
  return (
    <div id='page_circle_progress'>
        <div className="circle-moving"></div>
    </div>
  )
}
